<template>
  <article>
    <ValidationObserver v-slot="{ handleSubmit }">
      <form action @submit.prevent="handleSubmit(pay)" data-yapay="payment-form">
        <div class="mx-auto container flex flex-wrap text-gray-900 font-display">
          <div class="w-full lg:w-4/6 p-4 pt-0 md:p-24 md:pt-3">
            <CartItems></CartItems>
            <customer></customer>
            <addressContent />
            <Payment></Payment>
            <section class="pt-5 border-t border-gray-400 flex w-full flex-col items-center ">
              <t-button
                variant="pay"
                class="text-center font-bold block w-full hover:shadow"
                type="submit"
              >
                <i class="bx bxs-lock"></i>
                Finalizar pagamento
              </t-button>
              <div class="block mt-5 flex  justify-center">
                <img src="@/assets/img/comprasegura.png" alt="SSL" srcset="" width="125px">
                <img src="@/assets/img/estico-gray.png" alt="Estico Pay" srcset="" width="125px">
              </div>
            </section>
          </div>
          <div class="w-full lg:w-2/6">
            <CartDesktop></CartDesktop>
          </div>
        </div>
      </form>
    </ValidationObserver>
  </article>
</template>

<script>
import creditCardType from 'credit-card-type'
import Payment from '@/views/children/payment'
import addressContent from '@/views/children/address'
import customer from '@/views/children/customer'
import CartItems from '@/components/CartItems'
import CartDesktop from '@/components/CartDesktop'
import Payments from '@/payments'
import { extend } from 'vee-validate'
import { required, email } from 'vee-validate/dist/rules'
import { isValidCPF } from '@brazilian-utils/brazilian-utils'
extend('email', email)

// Override the default message.
extend('required', {
  ...required,
  message: 'Esse campo é obrigatório'
})

extend('email', {
  ...email,
  message: 'Endereço de e-mail não é valido'
})

extend('cpf', {
  message: 'Numero de CPF não é valido',
  validate: value => {
    return isValidCPF(value)
  }
})
extend('nome', {
  message: 'Utilize um nome completo',
  validate: value => {
    return !!value.match(/^[A-Za-záàâãéèêíïóôõöúçñ]* [A-Za-záàâãéèêíïóôõöúçñ]+/)
  }
})
export default {
  components: {
    CartItems, customer, addressContent, CartDesktop, Payment
  },
  computed: {
    paymentSelect () {
      return this.$store.state.paymentSelect
    }
  },
  data () {
    return {
      payment_select: '',
      customer_name: '',
      customer_email: '',
      customer_cpf: '',
      customer_phone: '',
      payment_method: '',
      payment: '',
      cardNumber: '',
      options: []
    }
  },
  methods: {
    async pay () {
      window.payment.senderHash = document.querySelector('input[name="finger_print"]').value
      if (this.paymentSelect === 1) {
        this.$store.state.cardBrand = creditCardType(this.$store.state.cardBin)[0].type
      }
      this.$store.commit('LOADER')
      this.$store.dispatch('payEstico', this.$route.params.token).then(response => {
        this.$router.push({
          name: 'order.show',
          params: {
            order: response.data.order
          }
        })
      }).catch((error) => {
        console.error(error)
      })
    }
  },
  mounted () {
    window.payment = Payments.getPayment('yapay')
    window.payment.init(false)
  },
  beforeDestroy () {
    window.payment = null
  }
}
</script>

<style>
</style>
